import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import Login from './screens/Login';
import States from './screens/States';
import DirectoryView from './screens/DirectoryView';
import PowerBi from './screens/PowerBi';
import Schedule from './screens/Schedule';
import DirectoryRegistry from './screens/DirectoryRegistry';
import UserRegistry from './screens/UserRegistry';
import UserList from './screens/UserList';
import Privileges from './screens/Privileges';
import FileRegistry from './screens/FileRegistry';
import PasswordRecovery from './screens/PasswordRecovery';
import PasswordReset from './screens/PasswordReset';
import EventRegistry from './screens/EventRegistry';

class AppRoutes extends Component {
  render() {
    return (
      <Switch>
        <Route exact path="/login" component={Login} />
        <Route exact path="/recover" component={PasswordRecovery} />
        <Route exact path="/reset" component={PasswordReset} />

        <Route exact path="/states" component={States} />
        <Route exact path="/monitoring" component={PowerBi} />

        <Route exact path="/schedule" component={Schedule} />
        <Route exact path="/registry/schedule/:event_date" component={EventRegistry} />

        <Route exact path="/directory/:id" component={DirectoryView} key={Math.random()} />
        <Route exact path="/registry/directory/:id" component={DirectoryRegistry} key={Math.random()} />
        <Route exact path="/privileges/:directory_id" component={Privileges} />

        <Route exact path="/registry/file/:id" component={FileRegistry} key={Math.random()} />

        <Route exact path="/registry/user" component={UserRegistry} />
        <Route exact path="/list/user" component={UserList} key={Math.random()} />

        <Redirect to="/login" />
      </Switch>
    );
  }
}

export default AppRoutes;
